module.exports = __webpack_public_path__ + "static/02-79d9b751c1b04d3cdfb82f5b2f206b05.jpg";